import type { NexusEdge } from "../../domain/mesh";

export const mockEdges: NexusEdge[] = [
  { id: "e01", source: "kaim-dev", target: "portfolio-frontier", relation: "contains", strength: 1 },
  { id: "e02", source: "kaim-dev", target: "goals", relation: "presents", strength: 0.72 },
  { id: "e03", source: "kaim-dev", target: "build", relation: "presents", strength: 0.72 },
  { id: "e04", source: "kaim-dev", target: "photos", relation: "presents", strength: 0.68 },
  { id: "e05", source: "kaim-dev", target: "okolica", relation: "presents", strength: 0.68 },
  { id: "e06", source: "kaim-dev", target: "home", relation: "presents", strength: 0.62 },
  { id: "e07", source: "kaim-dev", target: "breakglass", relation: "presents", strength: 0.62 },
  { id: "e08", source: "goals", target: "market-engine", relation: "contains", strength: 0.92 },
  { id: "e09", source: "goals", target: "house-goal", relation: "tracks", strength: 0.74 },
  { id: "e10", source: "build", target: "michalowice", relation: "located_at", strength: 0.9 },
  { id: "e11", source: "build", target: "house-goal", relation: "drives", strength: 0.96 },
  { id: "e12", source: "build", target: "house", relation: "drives", strength: 1 },
  { id: "e13", source: "build", target: "okolica", relation: "depends_on", strength: 0.82 },
  { id: "e14", source: "okolica", target: "michalowice", relation: "tracks", strength: 0.92 },
  { id: "e15", source: "photos", target: "photo-archive", relation: "contains", strength: 1 },
  { id: "e16", source: "home", target: "house", relation: "depends_on", strength: 0.92 },
  { id: "e17", source: "house", target: "michalowice", relation: "located_at", strength: 1 },
  { id: "e18", source: "house-goal", target: "house", relation: "drives", strength: 0.96 },
  { id: "e19", source: "home", target: "kaim-dev", relation: "depends_on", strength: 0.5 },
  { id: "e20", source: "breakglass", target: "portfolio-frontier", relation: "depends_on", strength: 0.58 },
  { id: "e21", source: "kaim-dev", target: "afery-lekarskie", relation: "presents", strength: 0.58 },
];
